import {
  LOAD_SPEAKERS,
  START_LOADING,
  STOP_LOADING,
} from "../constants/actionTypes";

const defaultState = {
  headers: [
    { label: "Ordering", sort: true, active: true, dir: "asc" },
    { label: "Name", sort: false, active: false, dir: "asc" },
    { label: "Bio", sort: false, active: false, dir: "asc" },
    { label: "Photo", sort: false, active: false, dir: "asc" },
    { label: "Active", sort: false, active: false, dir: "asc" },
    { label: "", sort: false, active: false, dir: "asc" },
  ],
  pagination: {
    total: 0,
    current_page: 1,
    per_page: 20,
    links: [],
  },
  speakers: [],
  currentPage: 1,
  currentLimit: 20,
  currentSearch: "",
  isLoading: false,
  speakerData: {
    ordering: 0,
    name: "",
    photo: "",
    bio: "",
    active: 0,
    id: 0,
  },
  action: "",
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case STOP_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    case LOAD_SPEAKERS:
      return {
        ...state,
        currentPage:
          action.payload?.success === true
            ? action.payload.pagination.current_page
            : 1,
        currentLimit:
          action.payload?.success === true
            ? action.payload.pagination.per_page
            : 10,
        currentSearch:
          action.payload?.success === true ? action.payload.search : "",
        speakers:
          action.payload?.success === true ? action.payload.speakers : [],
        pagination:
          action.payload?.success === true
            ? action.payload.pagination
            : defaultState.pagination,
        isLoading: false,
      };

    default:
      return state;
  }
};
